import { useState } from "react";
import { Smartphone, X } from "lucide-react";
import { Button } from "@/components/ui/button";
import { usePwaInstall } from "@/pwa/usePwaInstall";
import { IOSInstallDialog } from "@/components/pwa/IOSInstallDialog";
import { AndroidInstallDialog } from "@/components/pwa/AndroidInstallDialog";

export const InstallBanner = () => {
  const { canInstall, iosEligible, androidFallback, isStandalone, dismissed, promptInstall, dismiss } = usePwaInstall();
  const [iosOpen, setIosOpen] = useState(false);
  const [androidOpen, setAndroidOpen] = useState(false);

  if (isStandalone || dismissed || (!canInstall && !iosEligible && !androidFallback)) return null;

  const onCta = () => {
    if (canInstall) promptInstall();
    else if (iosEligible) setIosOpen(true);
    else setAndroidOpen(true);
  };

  return (
    <div className="rounded-2xl border border-primary/30 bg-primary/5 p-4 flex items-center gap-3" data-testid="install-banner">
      <span className="grid place-items-center h-10 w-10 rounded-xl bg-primary/10 text-primary shrink-0"><Smartphone className="h-5 w-5" /></span>
      <div className="flex-1 min-w-0">
        <div className="font-semibold text-sm">K9 Manager sul telefono</div>
        <p className="text-xs text-muted-foreground">Installalo sulla schermata Home per aprirlo come un’app.</p>
      </div>
      <Button size="sm" data-testid="install-banner-cta" className="rounded-full shrink-0" onClick={onCta}>Installa</Button>
      <button data-testid="install-banner-dismiss" aria-label="Non ora" onClick={dismiss}
        className="grid place-items-center h-8 w-8 rounded-full text-muted-foreground hover:bg-secondary shrink-0">
        <X className="h-4 w-4" />
      </button>
      <IOSInstallDialog open={iosOpen} onOpenChange={setIosOpen} />
      <AndroidInstallDialog open={androidOpen} onOpenChange={setAndroidOpen} />
    </div>
  );
};
